import axios from 'axios';
import {
    TRENDING_LABELS_WIDGET_DATA_KEY,
    TRENDING_LABELS_WIDGET_PREVIOUS_DATA_KEY
} from '@/assets/dashboard/cache-keys';
import toSnakeCaseThenStringify from '@/helpers/toSnakeCaseThenStringify';

export const state = () => ({});

export const getters = {
    DATA_KEY: () => TRENDING_LABELS_WIDGET_DATA_KEY,
    PREVIOUS_DATA_KEY: () => TRENDING_LABELS_WIDGET_PREVIOUS_DATA_KEY
};

export const mutations = {};

export const actions = {
    index(
        vuexContext,
        {
            limit,
            range,
            comparedRange,
            accountId,
            timeZone,
            properties,
            sort,
            order,
            search,
            nlpFields,
            tkwNumTerms,
            tkwNumSigTerms,
            tkwSigTerms
        }
    ) {
        const params = {
            range,
            comparedRange: comparedRange,
            limit,
            timeZone,
            accountId,
            sort,
            order,
            nlpFields,
            tkwNumTerms,
            tkwNumSigTerms,
            tkwSigTerms,
            keyword: search,
            properties: toSnakeCaseThenStringify(properties)
        };
        let path = '/v1/dashboard/trending_labels';

        return axios.getMethodOverridePost(path, { params, encodeURI: true });
    },

    csv(vuexContext, { limit, range, comparedRange, accountId, timeZone, properties, sort, order }) {
        const params = {
            range,
            comparedRange: comparedRange,
            limit,
            timeZone,
            accountId,
            sort,
            order,
            properties: toSnakeCaseThenStringify(properties)
        };

        return axios.getMethodOverridePost('/v1/dashboard/trending_labels.csv', { params, encodeURI: true });
    }
};
